import { ArrowDownIcon } from './ArrowDownIcon';

/**
 * author: Austin Andrews
 * id 3821BF79-5857-47BE-84E3-A100B7247535
 * name arrow-down
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down.svg
 * tags
 * - Arrow 
 */
export const ArrowBottomIcon = ArrowDownIcon;
export default ArrowBottomIcon